<div>

  <div class="align-center" *ngIf="orderStatuses">
    <br />
    <h2>{{ 'Orderstatus' | translate }}</h2>
    <hr>

    <div class="row align-center order-statuses">
      <div class="col">
        <h5>{{ 'Bearbetas' | translate }}</h5>
        <h3>{{orderStatuses['PENDING'] || 0}}</h3>
      </div>
      <div class="col">
        <h5>{{ 'Skickade till print' | translate }}</h5>
        <h3>{{orderStatuses['PRINTED'] || 0}}</h3>
      </div>
      <div class="col">
        <h5>{{ 'På väg' | translate }}</h5>
        <h3>{{orderStatuses['SHIPPED'] || 0}}</h3>
      </div>
    </div>
  </div>

  <br />
  <br />
  <div class="align-center">
    <h2>{{ 'Todo' | translate }}</h2>
    <hr>
  </div>
  <div *ngIf="hasTodo">
    <div *ngIf="todoOrders && todoOrders.length">
      <h4 class="align-center">{{ 'Ordrar som behöver din uppmärksamhet' | translate }}</h4>
      <table class="fullwidth styled">
        <tr>
          <th>#</th>
          <th>{{ 'Namn' | translate }}</th>
          <th>{{ 'Produkter' | translate }}</th>
          <th class="align-right">{{ 'Skapad' | translate }}</th>
          <th class="align-right">{{ 'Status' | translate }}</th>
        </tr>
        <tr *ngFor="let order of todoOrders">
          <td class="valign-top">
            <a [href]="globals.storeUrl('/poster-orders/' + order._id, globals.storeSettings._id, true)"
              target="_blank">{{order.orderNumber}}</a>
          </td>
          <td class="valign-top">
            <span *ngIf="order.shippingInfo">
              {{order.shippingInfo.firstName}} {{order.shippingInfo.lastName}}
            </span>
          </td>
          <td class="valign-top">
            <table class="fullwidth styled">
              <tr *ngFor="let item of order.items">
                <td>
                  {{item.quantity}}x
                </td>
                <td>
                  <order-item-administration [item]="item" [order]="order"></order-item-administration>
                </td>
              </tr>
            </table>
          </td>
          <td class="align-right valign-top">{{order.created | date:'yyyy-MM-dd HH:mm'}}</td>
          <td class="align-right valign-top">{{order.status}}</td>
        </tr>
      </table>

    </div>
  </div>
  <div *ngIf="!hasTodo && todoLoaded" class="align-center">
    <h4 class="align-center">{{ 'Inget att göra, allt är gott!' | translate }}</h4>
  </div>
</div>
